import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Link, Stack } from '@mui/material';
import { FlowDurationUnits } from 'flow-schema';
import { Link as ReactRouterLink } from 'react-router-dom';

import { Text } from 'common';

import { useReactFlowViewContext } from '../../../context/context';
import { BlockDurationField } from '../../ConfigFields/Duration';

interface FormTemplateDetailsProps {
  templateId: string;
  templateName: string;
  fieldNamePrefix: string;
  onRemove: () => void;
}

export function FormTemplateDetails(props: FormTemplateDetailsProps) {
  const { templateName, fieldNamePrefix, templateId, onRemove } = props;
  const { isEditable } = useReactFlowViewContext();
  return (
    <Stack
      sx={{
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '16px',
      }}
      flex={1}
      gap={1}
    >
      <Stack
        flexDirection="row"
        sx={{
          justifyContent: 'space-between',
          alignItems: 'start',
        }}
      >
        <Text color="primary" bold variant="body2">
          <Link
            component={ReactRouterLink}
            to={`/previsit-form-templates/${templateId}`}
            underline="hover"
            rel="noopener noreferrer"
            target="_blank"
          >
            {templateName}
          </Link>
        </Text>

        <IconButton onClick={() => onRemove()} disabled={!isEditable} size="small">
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Stack>
      <BlockDurationField
        variant="BlockValueTemplate"
        fieldName={`${fieldNamePrefix}.refreshInterval`}
        unitFieldNameSuffix="units"
        required={false}
        allowedUnits={Object.values(FlowDurationUnits)}
        toggleLabel="Add refresh interval"
        valueLabel="Refresh interval"
      />
    </Stack>
  );
}
